import React from 'react';

export default class OptGroup extends React.Component {
  static isSelectOptGroup = true;
}



// WEBPACK FOOTER //
// ./ext/select/src/OptGroup.jsx